import { HeadProps, PageProps, graphql } from 'gatsby'
import { Fragment } from 'react'

import { AdmissionsFAQ } from '@/features/admissions-sections'
import { Seo } from '@/features/common/'
import {
  ContactSection,
  GoFurtherSection,
  IntroSection,
  PageHero,
} from '@/features/page-sections'

const AdmissionsFaqPage = ({
  data: { datoCmsAdmissionsFaqPage: page },
}: PageProps<Queries.AdmissionsFaqPageQuery>): JSX.Element => {
  return (
    <Fragment>
      <PageHero
        heading={page?.pageHeading}
        heroImage={page?.heroImage}
      />
      <IntroSection
        heading={page?.introHeading}
        body={page?.introBody}
      />
      <AdmissionsFAQ data={page?.faq} />
      {page?.contact?.map((block, i) => (
        <ContactSection
          data={block}
          key={i}
        />
      ))}
      {page?.goFurther?.map((block, i) => (
        <GoFurtherSection
          data={block}
          key={i}
        />
      ))}
    </Fragment>
  )
}

export const Head = ({
  data: { datoCmsAdmissionsFaqPage: page },
}: HeadProps<Queries.AdmissionsFaqPageQuery>) => (
  <Seo seoMetaTags={page?.seoMetaTags} />
)

export const data = graphql`
  query AdmissionsFaqPage {
    datoCmsAdmissionsFaqPage {
      pageHeading
      heroImage {
        ...PageHero
      }
      introHeading
      introBody {
        ...BodyTextBlock
      }
      faq {
        ...AdmissionsFaqItem
      }
      contact {
        ...ContactSection
      }
      goFurther {
        ...GoFurtherSection
      }
      seoMetaTags {
        tags
      }
    }
  }
`

export default AdmissionsFaqPage
